if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        const init = () => {
          if (this._initialized) return;
          this.form = this.querySelector('form');
          if (!this.form) return;
          const variantInput = this.variantIdInput;
          if (variantInput) variantInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          // Prefer the nearest cart drawer when inside the drawer to avoid false negatives
          this.cart = this.closest('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
          if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.hideErrors = this.dataset.hideErrors === 'true';
          this._initialized = true;
        };

        // Try immediate init; if form not yet in DOM, observe until it appears
        init();
        if (!this._initialized) {
          const mo = new MutationObserver(() => {
            init();
            if (this._initialized && mo) mo.disconnect();
          });
          mo.observe(this, { childList: true, subtree: true });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form || !(this.form instanceof HTMLFormElement)) return;
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        let sectionsToRender = ['cart-icon-bubble'];
        if (this.cart) {
          sectionsToRender = [...sectionsToRender, ...this.cart.getSectionsToRender().map((section) => section.id)];
          this.cart.setActiveElement(document.activeElement);
        }
        
        const mainCartItemsSection = document.querySelector('.main-cart-items-section');
        const mainCartFooterSection = document.querySelector('.cart__footer-wrapper');
        
        if (mainCartItemsSection && mainCartItemsSection.id) {
          const sectionId = mainCartItemsSection.id.replace('shopify-section-', '');
          if (!sectionsToRender.includes(sectionId)) {
            sectionsToRender.push(sectionId);
          }
        }
        if (mainCartFooterSection && mainCartFooterSection.id) {
          const sectionId = mainCartFooterSection.id.replace('shopify-section-', '');
          if (!sectionsToRender.includes(sectionId)) {
            sectionsToRender.push(sectionId);
          }
        }
        
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (!soldOutMessage) return;
              if (this.submitButton) this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if (this.cart && typeof this.cart.renderContents === 'function') {
                        this.cart.renderContents(response);
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
                
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
                  const html = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
                  const newBubble = html.getElementById('cart-icon-bubble');
                  if (newBubble) {
                    cartIconBubble.innerHTML = newBubble.innerHTML;
                  }
                }
                
                const mainCartItemsSection = document.querySelector('.main-cart-items-section');
                if (mainCartItemsSection && response.sections) {
                  const sectionKey = mainCartItemsSection.id.replace('shopify-section-', '');
                  if (response.sections[sectionKey]) {
                    const html = new DOMParser().parseFromString(response.sections[sectionKey], 'text/html');
                    const newSection = html.getElementById(mainCartItemsSection.id);
                    if (newSection) {
                      mainCartItemsSection.outerHTML = newSection.outerHTML;
                      setTimeout(() => {
                        document.querySelectorAll('quantity-input').forEach(el => el.validateQtyRules?.());
                      }, 10);
                    }
                  }
                }
                
                const mainCartFooterSection = document.querySelector('.cart__footer-wrapper');
                if (mainCartFooterSection && response.sections) {
                  const sectionKey = mainCartFooterSection.id.replace('shopify-section-', '');
                  if (response.sections[sectionKey]) {
                    const html = new DOMParser().parseFromString(response.sections[sectionKey], 'text/html');
                    const newFooterSection = html.getElementById(mainCartFooterSection.id);
                    if (newFooterSection) {
                      mainCartFooterSection.outerHTML = newFooterSection.outerHTML;
                    }
                  }
                }
                
                setTimeout(() => {
                  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                }, 50);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
